import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import nl from '@angular/common/locales/nl';
import fr from '@angular/common/locales/fr';

import nlBe from '@angular/common/locales/nl-BE';
import frBe from '@angular/common/locales/fr-BE';
import { cultures, ICultures } from './cultures';

// minimal support for nl, nl-BE and en
// the application should register more if needed
registerLocaleData(nl);
registerLocaleData(nlBe);
registerLocaleData(en);
registerLocaleData(fr);
registerLocaleData(frBe);
@Injectable({
  providedIn: 'root',
})
export class UMLocalizationService {
  static cultures = { ...cultures };
  static allowedLocales = ['nl', 'en', 'fr'];
  private currentLocale: string;
  private readonly DISPLAY_LOCALE_KEY = 'displayLocale';

  constructor() {
    this.currentLocale = 'nl-be'; // default value in case it is never set
  }

  // Add extra locales you want to use in app
  static addLocales(locales: Array<any>): void {
    this.allowedLocales = [...this.allowedLocales, ...locales];
  }

  static getCultures(): ICultures {
    return UMLocalizationService.cultures;
  }

  static getCultureDisplay(cultureCode: string): string {
    return UMLocalizationService.cultures[cultureCode];
  }

  static addCulture(cultureCode: string, cultureDisplay: string): void {
    this.cultures[cultureCode] = cultureDisplay;
  }

  setLocale(locale: string): void {
    if (!locale) {
      throw new Error('No locale defined!');
    }
    const localeParts = locale.split('-');
    if (!UMLocalizationService.allowedLocales.includes(localeParts[0])) {
      locale = 'en';
    }
    if (localeParts.length === 1) {
      locale += '-be';
    }
    this.currentLocale = locale; // nl-be
  }

  getLocale(): string {
    return this.currentLocale; // ex.: en-be, nl-be
  }

  getLanguage(): string {
    return this.currentLocale.substring(0, 2); // ex.: en, nl
  }

  setDisplayLocale(locale: string): void {
    this.setLocale(locale);
    localStorage.setItem(this.DISPLAY_LOCALE_KEY, locale);
  }

  getDisplayLocale(): string | null {
    return localStorage.getItem(this.DISPLAY_LOCALE_KEY);
  }
}
